module.exports = __webpack_public_path__ + "static/Instacart-3c2d77550a34989b3ca111f098e36be9.jpg";